import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Timeline/TimelineItem.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Timeline/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', {
    staticClass: "order-detail",
    staticStyle: {
      "height": "100%",
      "min-height": "100vh"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "title font-size-h2-large"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.sendRevisedMap.send_revised_order_no))])]), _c('div', {
    staticClass: "state",
    style: {
      color: _vm.stateInfo.color
    }
  }, [_vm._v(" " + _vm._s(_vm.stateInfo.name) + " ")])]), _c('div', {
    staticClass: "customer font-size-h2-normal"
  }, [_c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-value text-color"
  }, [_vm._v(" " + _vm._s(_vm.sendRevisedMap.gps_addr + (_vm.sendRevisedMap.detail_addr || '')) + " ")])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-value text-color gray"
  }, [_vm._v(" " + _vm._s(_vm.sendRevisedMap.custom_linkperson) + ": " + _vm._s(_vm.sendRevisedMap.custom_phone) + " ")])])])]), _c('div', {
    staticClass: "box"
  }, [_c('h6', [_vm._v(i18n.tc("226"))]), _vm._l(_vm.orderInfo.customerProlist || [], function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "box-info"
    }, [_c('img', {
      staticClass: "icon-i",
      attrs: {
        "src": _vm.replaceMultiImg(item.img_url || '/spa_static_mobile/icon/spare120_120@3x.png'),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "info"
    }, [[_c('div', [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.productionName))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(i18n.tc("227") + _vm._s(item.production_sn_uncheck))])])]], 2)]);
  })], 2), _c('div', {
    staticClass: "box"
  }, [_c('h6', [_vm._v(i18n.tc("398"))]), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.sendRevisedMap.groupName))]), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.sendRevisedMap.revisedAddr))]), _c('div', {
    staticClass: "name-2"
  }, [_vm._v(_vm._s(_vm.sendRevisedMap.revisedLinkman) + ": " + _vm._s(_vm.sendRevisedMap.revisedLinkmanPhone))])])]), _c('div', {
    staticClass: "box"
  }, [_c('h6', [_vm._v(i18n.tc("399"))]), _c(__unplugin_components_0, {
    attrs: {
      "list": _vm.logList
    }
  }, _vm._l(_vm.logList, function (log, index) {
    return _c(__unplugin_components_1, {
      key: index,
      attrs: {
        "dash": index !== _vm.logList.length - 1
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.getLogType(log.type)) + " ")]), _c('div', {
      attrs: {
        "slot": "date"
      },
      slot: "date"
    }, [_vm._v(" " + _vm._s(log.create_time) + " ")]), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(" " + _vm._s(log.content) + " ")])]);
  }), 1)], 1)])], 1), !_vm.sendRevisedMap.send_state && _vm.stateInfo.id !== 0 ? _c('div', {
    staticClass: "bottom-bar"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'SignIn',
          query: {
            orderId: _vm.orderId
          }
        });
      }
    }
  }, [_vm._v(" " + i18n.tc("118") + " ")])], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };